import React from 'react';
import ReactPaginate from 'react-paginate';
import { navigate, withPrefix } from 'gatsby';
//hooks
import { useDirectusData } from '../hooks/directusHooks/useDirectusData';
// components
import SEO from '../components/seo';
import BlogCategories from '../components/blog-categories/blog-categories';
import BlogArticles from '../components/blog-articles/blog-articles';
import BlogSectionPrimary from '../components/blog-section-primary/blog-section-primary';
//interfaces
import { IArticlesData } from '@vitl-services/interfaces/blog';
//services
import { getImageUrlFromFilename } from '@vitl-services/services/format';
//styles
import * as styles from './blog-layout.module.scss';

/**
 * * This template shows a primary section, category button labels and a list of articles.
 * * It's used both for the articles and category pages
 */
interface IProps {
  articlesData: IArticlesData;
  pageContext: any;
}

const BlogLayout: React.FC<IProps> = ({ articlesData, pageContext }) => {
  const { numPages, slug = '', currentPage } = pageContext || {};
  const { settingsData, categoriesData, topArticlesData } = useDirectusData();
  const {
    page_title: pageTitle,
    page_description: pageDescription,
    blog_title: blogTitle,
    blog_hero_image,
  } = settingsData;

  const heroImage = getImageUrlFromFilename(blog_hero_image?.filename_disk);

  const createPaginationLink = (
    pageNumber: number | undefined,
    pageCount?: number
  ) => {
    let link = '#';
    if (pageNumber === undefined) return link;

    pageNumber = pageNumber + 1;

    const isFirstPage = pageNumber === 1;
    const isSlugHome = slug === '';
    const isPageNumberPageCount = pageCount && pageNumber >= pageCount;

    if (pageNumber >= 1 || isPageNumberPageCount) {
      link = isFirstPage
        ? `/${slug}`
        : isSlugHome
        ? `/${pageNumber}`
        : `/${slug}/${pageNumber}`;
    }
    return link;
  };

  const handlePagination = (pageSelected: number | undefined) => {
    navigate(createPaginationLink(pageSelected));
  };

  return (
    <>
      <SEO {...{ title: pageTitle, description: pageDescription }} />
      <BlogSectionPrimary {...{ blogTitle, heroImage }} />
      <BlogCategories {...{ slug, categoriesData }} />
      <BlogArticles {...{ settingsData, articlesData, topArticlesData }} />
      <section className={styles.section}>
        <ReactPaginate
          breakLabel="..."
          breakClassName={styles.paginationButton}
          breakLinkClassName={styles.paginationLink}
          nextLabel=">"
          pageRangeDisplayed={5}
          initialPage={currentPage - 1}
          pageCount={numPages || 1}
          previousLabel="<"
          previousLinkClassName={styles.paginationLink}
          nextLinkClassName={styles.paginationLink}
          onClick={({ nextSelectedPage }) => handlePagination(nextSelectedPage)}
          prevRel="prev"
          nextRel="next"
          data-testid="pagination"
          hrefBuilder={(page, pageCount) => {
            return withPrefix(createPaginationLink(page - 1, pageCount));
          }}
          hrefAllControls={true}
          className={styles.pagination}
          pageClassName={styles.paginationButton}
          pageLinkClassName={styles.paginationLink}
          activeClassName={styles.paginationButtonActive}
          previousClassName={styles.paginationButton}
          nextClassName={styles.paginationButton}
        />
      </section>
    </>
  );
};

export default BlogLayout;
